module.exports = __webpack_public_path__ + "img/clipboard-text.cc090964.svg";